import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Divider from '@mui/material/Divider';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { RichTextField, TextField } from '@sitecore-jss/sitecore-jss-nextjs';
import React from 'react';
import { StudyLocationMergeTag } from './StudyLocationMergeTag';
import UiText from '../shared/Typography/UiText';
import validateEmptyRichText from './validateEmptyRichText';
import { DEFAULT_PRIMARY_FONT_FAMILY } from 'theme/fontDefaults';

interface IStudyLocationCardProps {
  enrollingText: TextField;
  notYetEnrollingText: TextField;
  siteAddressFormat: RichTextField;
  studyDetails: any;
  titleFormat: RichTextField;
}

export const StTagInfo = styled(Box)(({ theme }) => ({
  borderRadius: '5px',
  color: '#FFF',
  fontFamily: `${theme?.palette?.primaryFontFamilyType || DEFAULT_PRIMARY_FONT_FAMILY}, sans-serif`,
  fontSize: '13px',
  fontStyle: 'normal',
  fontWeight: '500',
  padding: '0.25rem 0.5rem',
}));

const StudyLocationCard = (props: IStudyLocationCardProps) => {
  const theme = useTheme();
  const titleFormat = props?.titleFormat;

  return (
    <Card
      tabIndex={0}
      sx={{
        borderRadius: '8px',
        boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.08)',
        height: '100%',
      }}
    >
      <CardContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          gap: '0.5rem',
        }}
      >
        {props.studyDetails?.raw?.locationstatus === 'Enrolling' ? (
          <StTagInfo sx={{ background: theme.palette.teal.main }}>
            {props?.studyDetails?.raw?.locationstatus}
          </StTagInfo>
        ) : (
          <StTagInfo sx={{ background: '#595959' }}>
            {props?.studyDetails?.raw?.locationstatus}
          </StTagInfo>
        )}

        {!validateEmptyRichText(titleFormat?.value) && (
          <UiText bold>
            <StudyLocationMergeTag field={titleFormat} rawData={props.studyDetails?.raw} />
          </UiText>
        )}
        {!validateEmptyRichText(titleFormat?.value) &&
          !validateEmptyRichText(props?.siteAddressFormat?.value) && <Divider flexItem={true} />}
        {!validateEmptyRichText(props?.siteAddressFormat?.value) && (
          <UiText size="caption">
            <StudyLocationMergeTag
              field={props?.siteAddressFormat}
              rawData={props.studyDetails?.raw}
            />
          </UiText>
        )}
      </CardContent>
    </Card>
  );
};

export default StudyLocationCard;
